import { MessageUnionType, ToolOutput } from '@/types/schema';
import {
  OpenAIBuiltinTool,
  isAnthropicTools,
  isAnthropicToolsAndBuiltins,
  isOpenAIFunctions,
  isOpenAIResponseTools,
  isOpenAITools,
  isVertexAITools,
} from '@/utils/ai-tools';
import {
  getFlattenedArrayOfGenerations,
  getInvocationParams,
  getMessageFields,
} from '@/utils/messages';

import { RunDisplaySchema } from './types';
import { getOutputMessagesWithIndex } from './utils';

export function getRecognizedToolsFromRun(run: RunDisplaySchema) {
  const params = getInvocationParams(run);
  const tools =
    params?.['tools'] ||
    // wrapOpenAI JS SDK
    params?.['args']?.[0]?.['tools'];

  const functions = params?.['functions'];
  const recognizedTools = isOpenAITools(tools)
    ? tools.map((i) => i.function)
    : isOpenAIResponseTools(tools)
    ? tools
    : isVertexAITools(tools) && isOpenAIFunctions(tools[0].functionDeclarations)
    ? tools[0].functionDeclarations
    : isAnthropicTools(tools)
    ? tools
    : isAnthropicToolsAndBuiltins(tools)
    ? tools
    : isOpenAIFunctions(functions)
    ? functions
    : isAnthropicTools(functions)
    ? functions
    : null;

  // Handle MCP list tools
  const mcp = recognizedTools?.find((f) => 'type' in f && f.type === 'mcp') as
    | OpenAIBuiltinTool
    | undefined;
  if (mcp) {
    const outputs = run.outputs;
    const generations = getFlattenedArrayOfGenerations(outputs);
    const outputMessagesWithIndex = getOutputMessagesWithIndex(generations);
    const outputMessages = outputMessagesWithIndex?.map(
      (m) => m?.[0] as MessageUnionType
    );
    const messageFields = outputMessages?.map((m) => getMessageFields(m));
    const mcpListTools = messageFields?.find((m) =>
      m?.additional_kwargs?.tool_outputs?.find(
        (t) => t.type === 'mcp_list_tools'
      )
    );
    if (mcpListTools) {
      const mcpToolsUsed = mcpListTools.additional_kwargs?.tool_outputs
        ?.filter(
          (t): t is ToolOutput & { type: 'mcp_call' } => t.type === 'mcp_call'
        )
        ?.map((t) => t.name);
      const mcpListToolOutput =
        mcpListTools.additional_kwargs?.tool_outputs?.find(
          (t): t is ToolOutput & { type: 'mcp_list_tools' } =>
            t.type === 'mcp_list_tools'
        );
      const mcpTools = mcpListToolOutput?.tools?.map((t) => ({
        ...t,
        used: !!mcpToolsUsed?.includes(t.name),
      }));
      return recognizedTools?.map((f) => {
        if ('type' in f && f.type === 'mcp') {
          return {
            ...f,
            tools: mcpTools,
          };
        }
        return f;
      });
    }
  }

  return recognizedTools;
}
